const AquaaActionTypes = {

    SAVE_EVALUATION_DATA: "SAVE_EVALUATION_DATA",

    GET_AQUAA_ACCOUNTS_DATA: "GET_AQUAA_ACCOUNTS_DATA",
    AQUAA_ACCOUNTS_DATA: "AQUAA_ACCOUNTS_DATA",

    GET_AQUAA_AGENTS_DATA: "GET_AQUAA_AGENTS_DATA",
    AQUAA_AGENTS_DATA: "AQUAA_AGENTS_DATA",

    GET_AQUAA_CHANNELS_DATA: "GET_AQUAA_CHANNELS_DATA",
    AQUAA_CHANNELS_DATA: "AQUAA_CHANNELS_DATA",

    GET_AQUAA_LANGUAGES_DATA: "GET_AQUAA_LANGUAGES_DATA",
    AQUAA_LANGUAGES_DATA: "AQUAA_LANGUAGES_DATA",

    GET_AQUAA_LOCATIONS_DATA: "GET_AQUAA_LOCATIONS_DATA",
    AQUAA_LOCATIONS_DATA: "AQUAA_LOCATIONS_DATA",

    GET_AQUAA_VALIDFROM_DATA: "GET_AQUAA_VALIDFROM_DATA",
    AQUAA_VALIDFROM_DATA: "AQUAA_VALIDFROM_DATA",

    GET_AQUAA_MARKETGROUP_DATA: "GET_AQUAA_MARKETGROUP_DATA",
    AQUAA_MARKETGROUP_DATA: "AQUAA_MARKETGROUP_DATA",

    GET_AQUAA_AWS_DATA: "GET_AQUAA_AWS_DATA",
    AQUAA_AWS_DATA: "AQUAA_AWS_DATA",

    GET_EVALUATION_FORM_DATA: "GET_EVALUATION_FORM_DATA",
    EVALUATION_FORM_DATA: "EVALUATION_FORM_DATA",

    UPDATE_EVALUATION_FORM_DATA_START: "UPDATE_EVALUATION_FORM_DATA_START",
    UPDATE_EVALUATION_FORM_DATA_SUCCESS: "UPDATE_EVALUATION_FORM_DATA_SUCCESS",

    GET_SAVED_EVALUATIONS_DATA: "GET_SAVED_EVALUATIONS_DATA",
    SAVED_EVALUATIONS_DATA: "SAVED_EVALUATIONS_DATA",

    GET_SUBMITTED_EVALUATIONS_DATA: "GET_SUBMITTED_EVALUATIONS_DATA",
    SUBMITTED_EVALUATIONS_DATA: "SUBMITTED_EVALUATIONS_DATA",

    GET_SAVED_EVALUATION_FORM_DATA: "GET_SAVED_EVALUATION_FORM_DATA",
    SAVED_EVALUATION_FORM_DATA: "SAVED_EVALUATION_FORM_DATA",

    GET_ADDITIONAL_RECIPIENTS: "GET_ADDITIONAL_RECIPIENTS",
    ADDITIONAL_RECIPIENTS: "ADDITIONAL_RECIPIENTS",

    GET_AQUAA_NONASD_ACCOUNTS_DATA: "GET_AQUAA_NONASD_ACCOUNTS_DATA",
    AQUAA_NONASD_ACCOUNTS_DATA: "AQUAA_NONASD_ACCOUNTS_DATA",

    GET_AQUAA_NONASD_CHANNELS_DATA: "GET_AQUAA_NONASD_CHANNELS_DATA",
    AQUAA_NONASD_CHANNELS_DATA: "AQUAA_NONASD_CHANNELS_DATA",

    GET_AQUAA_NONASD_LOCATIONS_DATA: "GET_AQUAA_NONASD_LOCATIONS_DATA",
    AQUAA_NONASD_LOCATIONS_DATA: "AQUAA_NONASD_LOCATIONS_DATA",

    GET_AQUAA_NONASD_LANGUAGES_DATA: "GET_AQUAA_NONASD_LANGUAGES_DATA",
    AQUAA_NONASD_LANGUAGES_DATA: "AQUAA_NONASD_LANGUAGES_DATA",

    GET_AQUAA_NONASD_AGENTS_DATA: "GET_AQUAA_NONASD_AGENTS_DATA",
    AQUAA_NONASD_AGENTS_DATA: "AQUAA_NONASD_AGENTS_DATA",

    GET_NONASD_EVALUATION_FORM_DATA: "GET_NONASD_EVALUATION_FORM_DATA",
    NONASD_EVALUATION_FORM_DATA: "NONASD_EVALUATION_FORM_DATA",

    GET_AGENT_EVALUATIONS_DATA: "GET_AGENT_EVALUATIONS_DATA",
    AGENT_EVALUATIONS_DATA: "AGENT_EVALUATIONS_DATA",

    GET_AQUAA_ADMIN_ACCOUNTS_DATA: "GET_AQUAA_ADMIN_ACCOUNTS_DATA",
    AQUAA_ADMIN_ACCOUNTS_DATA: "AQUAA_ADMIN_ACCOUNTS_DATA",

    GET_AQUAA_ADMIN_ACCOUNTS_TABLE_DATA: "GET_AQUAA_ADMIN_ACCOUNTS_TABLE_DATA",
    AQUAA_ADMIN_ACCOUNTS_TABLE_DATA: "AQUAA_ADMIN_ACCOUNTS_TABLE_DATA",

    GET_AQUAA_ADMIN_CHANNELS_DATA: "GET_AQUAA_ADMIN_CHANNELS_DATA",
    AQUAA_ADMIN_CHANNELS_DATA: "AQUAA_ADMIN_CHANNELS_DATA",

    GET_AQUAA_ADMIN_CONTACTTYPE_TABLE_DATA: "GET_AQUAA_ADMIN_CONTACTTYPE_TABLE_DATA",
    AQUAA_ADMIN_CONTACTTYPE_TABLE_DATA: "AQUAA_ADMIN_CONTACTTYPE_TABLE_DATA",

    UPDATE_AQUAA_ADMIN_ACCOUNT_DATA_START: "UPDATE_AQUAA_ADMIN_ACCOUNT_DATA_START",
    UPDATE_AQUAA_ADMIN_ACCOUNT_DATA_SUCCESS: "UPDATE_AQUAA_ADMIN_ACCOUNT_DATA_SUCCESS",

    UPDATE_AQUAA_ADMIN_CONTACTTYPE_DATA_START: "UPDATE_AQUAA_ADMIN_CONTACTTYPE_DATA_START",
    UPDATE_AQUAA_ADMIN_CONTACTTYPE_DATA_SUCCESS: "UPDATE_AQUAA_ADMIN_CONTACTTYPE_DATA_SUCCESS",

    GET_AQUAA_QUESTION_ASSESSMENTS_DATA: "GET_AQUAA_QUESTION_ASSESSMENTS_DATA",
    AQUAA_QUESTION_ASSESSMENTS_DATA: "AQUAA_QUESTION_ASSESSMENTS_DATA",

    GET_AQUAA_ADMIN_QUESTIONS_TABLE_DATA: "GET_AQUAA_ADMIN_QUESTIONS_TABLE_DATA",
    AQUAA_ADMIN_QUESTIONS_TABLE_DATA: "AQUAA_ADMIN_QUESTIONS_TABLE_DATA",

    UPDATE_AQUAA_ADMIN_QUESTIONS_DATA_START: "UPDATE_AQUAA_ADMIN_QUESTIONS_DATA_START",
    UPDATE_AQUAA_ADMIN_QUESTIONS_DATA_SUCCESS: "UPDATE_AQUAA_ADMIN_QUESTIONS_DATA_SUCCESS",

    UPDATE_AQUAA_ACKNOWLEDGEMENT_DATA_START: "UPDATE_AQUAA_ACKNOWLEDGEMENT_DATA_START",
    UPDATE_AQUAA_ACKNOWLEDGEMENT_DATA_SUCCESS: "UPDATE_AQUAA_ACKNOWLEDGEMENT_DATA_SUCCESS",

    GET_AQUAA_MAPPING_ACCOUNTS: "GET_AQUAA_MAPPING_ACCOUNTS",
    AQUAA_MAPPING_ACCOUNTS: "AQUAA_MAPPING_ACCOUNTS",

    GET_AQUAA_MAPPING_CONTACTTYPE_FORMS: "GET_AQUAA_MAPPING_CONTACTTYPE_FORMS",
    AQUAA_MAPPING_CONTACTTYPE_FORMS: "AQUAA_MAPPING_CONTACTTYPE_FORMS",

    GET_AQUAA_MAPPING_COUNTRIES: "GET_AQUAA_MAPPING_COUNTRIES",
    AQUAA_MAPPING_COUNTRIES: "AQUAA_MAPPING_COUNTRIES",

    GET_AQUAA_MAPPING_SECTIONS: "GET_AQUAA_MAPPING_SECTIONS",
    AQUAA_MAPPING_SECTIONS: "AQUAA_MAPPING_SECTIONS",

    GET_AQUAA_MAPPING_QUESTIONS: "GET_AQUAA_MAPPING_QUESTIONS",
    AQUAA_MAPPING_QUESTIONS: "AQUAA_MAPPING_QUESTIONS",

    GET_AQUAA_MAPPING_PARAMETERTYPE: "GET_AQUAA_MAPPING_PARAMETERTYPE",
    AQUAA_MAPPING_PARAMETERTYPE: "AQUAA_MAPPING_PARAMETERTYPE",

    UPDATE_AQUAA_MAPPING_DATA_START: "UPDATE_AQUAA_MAPPING_DATA_START",
    UPDATE_AQUAA_MAPPING_DATA_SUCCESS: "UPDATE_AQUAA_MAPPING_DATA_SUCCESS",

    GET_AQUAA_EVALUATIONS_DELETE: "GET_AQUAA_EVALUATIONS_DELETE",
    AQUAA_EVALUATIONS_DELETE: "AQUAA_EVALUATIONS_DELETE",

    UPDATE_AQUAA_EVALUATIONS_DELETE_START: "UPDATE_AQUAA_EVALUATIONS_DELETE_START",
    UPDATE_AQUAA_EVALUATIONS_DELETE_SUCCESS: "UPDATE_AQUAA_EVALUATIONS_DELETE_SUCCESS",

    GET_AQUAA_VALIDATE_TICKET_NO: "GET_AQUAA_VALIDATE_TICKET_NO",
    AQUAA_VALIDATE_TICKET_NO: "AQUAA_VALIDATE_TICKET_NO",

    GET_AQUAA_ICED_AGENTS: "GET_AQUAA_ICED_AGENTS",
    AQUAA_ICED_AGENTS: "AQUAA_ICED_AGENTS",

    GET_AQUAA_ICED_ACCOUNTS: "GET_AQUAA_ICED_ACCOUNTS",
    AQUAA_ICED_ACCOUNTS: "AQUAA_ICED_ACCOUNTS",

    GET_AQUAA_ICED_TABLE_DATA: "GET_AQUAA_ICED_TABLE_DATA",
    AQUAA_ICED_TABLE_DATA: "AQUAA_ICED_TABLE_DATA",

    GET_AQUAA_ICED_L1_CATEGORY: "GET_AQUAA_ICED_L1_CATEGORY",
    AQUAA_ICED_L1_CATEGORY: "AQUAA_ICED_L1_CATEGORY",

    GET_AQUAA_ICED_L2_CATEGORY: "GET_AQUAA_ICED_L2_CATEGORY",
    AQUAA_ICED_L2_CATEGORY: "AQUAA_ICED_L2_CATEGORY",

    UPDATE_AQUAA_ICED_DATA_START: "UPDATE_AQUAA_ICED_DATA_START",
    UPDATE_AQUAA_ICED_DATA_SUCCESS: "UPDATE_AQUAA_ICED_DATA_SUCCESS",

    GET_AQUAA_ICED_EVALUATIONS_DATA: "GET_AQUAA_ICED_EVALUATIONS_DATA",
    AQUAA_ICED_EVALUATIONS_DATA: "AQUAA_ICED_EVALUATIONS_DATA",

    GET_ACCOUNT_EVALUATOR_ACCOUNTS_DATA: "GET_ACCOUNT_EVALUATOR_ACCOUNTS_DATA",
    ACCOUNT_EVALUATOR_ACCOUNTS_DATA: "ACCOUNT_EVALUATOR_ACCOUNTS_DATA",

    GET_ACCOUNT_EVALUATOR_EVALUATORS_DATA: "GET_ACCOUNT_EVALUATOR_EVALUATORS_DATA",
    ACCOUNT_EVALUATOR_EVALUATORS_DATA: "ACCOUNT_EVALUATOR_EVALUATORS_DATA",

    GET_ACCOUNT_EVALUATOR_TABLE_DATA: "GET_ACCOUNT_EVALUATOR_TABLE_DATA",
    ACCOUNT_EVALUATOR_TABLE_DATA: "ACCOUNT_EVALUATOR_TABLE_DATA",

    UPDATE_ACCOUNT_EVALUATOR_MAPPING_DATA_START: "UPDATE_ACCOUNT_EVALUATOR_MAPPING_DATA_START",
    UPDATE_ACCOUNT_EVALUATOR_MAPPING_DATA_SUCCESS: "UPDATE_ACCOUNT_EVALUATOR_MAPPING_DATA_SUCCESS",

    UPDATE_NEW_EVALUATOR_DATA_START: "UPDATE_NEW_EVALUATOR_DATA_START",
    UPDATE_NEW_EVALUATOR_DATA_SUCCESS: "UPDATE_NEW_EVALUATOR_DATA_SUCCESS",

    GET_ACCOUNT_EVALUATOR_USERS_DATA: "GET_ACCOUNT_EVALUATOR_USERS_DATA",
    ACCOUNT_EVALUATOR_USERS_DATA: "ACCOUNT_EVALUATOR_USERS_DATA",

    GET_ICED_REPORTS_ACCOUNTS: "GET_ICED_REPORTS_ACCOUNTS",
    ICED_REPORTS_ACCOUNTS: "ICED_REPORTS_ACCOUNTS",

    GET_ICED_MASTER_DATA: "GET_ICED_MASTER_DATA",
    ICED_MASTER_DATA: "ICED_MASTER_DATA",

    UPDATE_ICED_DATA_START: "UPDATE_ICED_DATA_START",
    UPDATE_ICED_DATA_SUCCESS: "UPDATE_ICED_DATA_SUCCESS",

    GET_ICED_TABLE_DATA: "GET_ICED_TABLE_DATA",
    ICED_TABLE_DATA: "ICED_TABLE_DATA",

    UPDATE_SUBMITTED_COMMENTS_DATA_START: "UPDATE_SUBMITTED_COMMENTS_DATA_START",
    UPDATE_SUBMITTED_COMMENTS_DATA_SUCCESS: "UPDATE_SUBMITTED_COMMENTS_DATA_SUCCESS",

    GET_RECOMMENDATIONS_TABLE_DATA: "GET_RECOMMENDATIONS_TABLE_DATA",
    RECOMMENDATIONS_TABLE_DATA: "RECOMMENDATIONS_TABLE_DATA",

    UPDATE_TRAINING_ASSIGNMENT_DATA_START: "UPDATE_TRAINING_ASSIGNMENT_DATA_START",
    UPDATE_TRAINING_ASSIGNMENT_DATA_SUCCESS: "UPDATE_TRAINING_ASSIGNMENT_DATA_SUCCESS",

    UPDATE_TRAINING_COMMENTS_DATA_START: "UPDATE_TRAINING_COMMENTS_DATA_START",
    UPDATE_TRAINING_COMMENTS_DATA_SUCCESS: "UPDATE_TRAINING_COMMENTS_DATA_SUCCESS",

    GET_TRAINER_TABLE_DATA: "GET_TRAINER_TABLE_DATA",
    TRAINER_TABLE_DATA: "TRAINER_TABLE_DATA",

    UPDATE_AGENT_TRAINING_COMMENTS_DATA_START: "UPDATE_AGENT_TRAINING_COMMENTS_DATA_START",
    UPDATE_AGENT_TRAINING_COMMENTS_DATA_SUCCESS: "UPDATE_AGENT_TRAINING_COMMENTS_DATA_SUCCESS",

    GET_RECOMMENDATIONS_DROPDOWN_DATA: "GET_RECOMMENDATIONS_DROPDOWN_DATA",
    RECOMMENDATIONS_DROPDOWN_DATA: "RECOMMENDATIONS_DROPDOWN_DATA",

    UPDATE_EF_MISSING_DATA_START: "UPDATE_EF_MISSING_DATA_START",
    UPDATE_EF_MISSING_DATA_SUCCESS:'UPDATE_EF_MISSING_DATA_SUCCESS'






  };
  
  export default AquaaActionTypes;
  